import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import LeftSideBar from "../../../components/LeftSideBar/LeftSideBar";
import { Box, Button, Grid, IconButton } from "@mui/material";
import * as acts from "../../../redux/administrator/actions";
import { useDispatch, useSelector } from "react-redux";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";

import { Document, Page, pdfjs } from "react-pdf";
import TextField from "@mui/material/TextField";
import DateRangePicker from "../../../components/DateRangePicker";
import "./dataDeletion.scss";
import AdministratorHeader from "../../../components/Header/AdministratorHeader";
import moment from "moment";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Autocomplete from "@mui/material/Autocomplete";
import CustomizedSnackbars from "../../../components/Snackbars/CustomizedSnackbars";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const Index = () => {
  const Dispatch = useDispatch();
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [input, setInput] = useState("");
  const [file, setFile] = useState("");
  const [listData, setListData] = useState([]);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState(false);

  const data = useSelector((state) => state?.admin?.deletedData);

  useEffect(() => {
    Dispatch(
      acts.getDeletedData({
        formattedStartDate: "",
        formattedEndDate: "",
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (data && data.length > 0) {
      setListData([...data]);
    } else {
      setListData([]);
    }
    if (data && data !== undefined) {
      if (data?.message !== null && data?.next === false) {
        setMessage(data?.message);
        setErr(true);
      }
    }
  }, [data]);

  const handleChange = (event, data) => {
    if (!data) {
      setInput("");
      setFile("");
    } else {
      setFile(data?.url);
      setInput(data?.name);
    }
  };

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }
  const filterByDate = (startDate, endDate, status) => {
    const formattedStartDate =
      startDate !== "" ? moment(startDate).format("YYYY-MM-DD") : "";
    const formattedEndDate =
      endDate !== "" ? moment(endDate).format("YYYY-MM-DD") : "";
    Dispatch(
      acts.getDeletedData({
        formattedStartDate,
        formattedEndDate,
      })
    );
  };

  const downloadPdf = (file) => {
    const link = document.createElement("a");
    link.href = file;
    link.target = "_blank"; // Open in a new tab
    link.click();
  };
  const clear = () => {
    Dispatch(
      acts.getDeletedData({
        formattedStartDate: "",
        formattedEndDate: "",
      })
    );
  };

  return (
    <>
      <Header page="new-project" />
      <Box>
        <Grid className="sidebar-main" container>
          <Grid item className="sidebar-container">
            <LeftSideBar page="sidebar" />
          </Grid>
          <Grid item className="visualization-conatiner data-deletion-wrap">
            <AdministratorHeader text="Data Deletion Reports" />
            <Grid container className="input-wrap">
              <Grid item md={4}>
                <DateRangePicker filterByDate={filterByDate} clear={clear} />
              </Grid>
              <Grid item md={6} className="selectDataReport-wrap">
                <FormControl className="selectDataReport">
                  <InputLabel className="select-label">Select File</InputLabel>
                  <Autocomplete
                    options={listData.map((list) => ({
                      name: list?.report_name,
                      url: list?.url,
                    }))}
                    getOptionLabel={(option) => option?.name}
                    inputValue={input}
                    filterSelectedOptions={true}
                    onChange={handleChange}
                    onInputChange={(event, newInputValue) =>
                      setInput(newInputValue)
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        placeholder="Select File"
                        onChange={({ target }) => setInput(target.value)}
                        fullWidth
                      />
                    )}
                  />
                </FormControl>
              </Grid>
              <Grid className="download-pdf" item md={1}>
                <Button
                  onClick={() => downloadPdf(file)}
                  size="medium"
                  className="download-pdf_-btn"
                  startIcon={<FileDownloadIcon />}
                  disabled={file === ""}
                >
                  download
                </Button>
              </Grid>
            </Grid>
            {err && (
              <CustomizedSnackbars
                severity="error"
                state={err}
                text={message}
                handleClose={() => setErr(false)}
              />
            )}

            <Box className="data-deletion-document">
              <Box className="pagination">
                <div className="p-sticky">
                  <label className="paginationLabel">Page {pageNumber}</label>
                  <IconButton
                    aria-label="left"
                    onClick={() =>
                      pageNumber === 1 ? "" : setPageNumber(pageNumber - 1)
                    }
                    disabled={pageNumber === 1}
                  >
                    <ChevronLeftIcon />
                  </IconButton>
                  <IconButton
                    aria-label="right"
                    onClick={() => setPageNumber(pageNumber + 1)}
                    disabled={pageNumber === numPages}
                  >
                    <ChevronRightIcon />
                  </IconButton>
                </div>
              </Box>
              <Document file={file || ""} onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} />
              </Document>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
export default Index;
